type ReadingStatusProps = {
  status: string;
};

export const ReadingStatus = ({ status }: ReadingStatusProps) => {
  return (
    <div>
      <p className="text-sm font-medium mb-2">Estado</p>
      <div 
        className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium" 
        style={{
          backgroundColor: status === 'completed' ? '#e2e8f0' : '#fef3c7',
          color: status === 'completed' ? '#475569' : '#92400e'
        }}
      >
        {status === 'completed' ? 'Completada' : 'Pendiente'}
      </div>
    </div>
  );
};